import { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { browseCategoriesTitle } from "../../messages";
import { callAPIInterface, categoryColors } from "../../constants";
import Text from "../../text/Text";
import { categoryBackgroundImage as bgImage } from "../../images";
import MiniAppHeading from "../MiniAppHeading";
import CategoryDetails from "./CategoryDetails";
import { setCategoryData } from "../../../redux/actions";
import { useSession } from "../../../hooks/useSession";

function CategoriesList({ isShowHeading = true }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { session } = useSession();

  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [categoryDetailsInfo, setCategoryDetailsInfo] = useState({});

  const { categories } = useSelector((state) => state.common);

  useEffect(() => {
    if (session) {
      fetchCategories();
    }
  }, [session]);

  const fetchCategories = async () => {
    try {
      const response = await callAPIInterface(
        "POST",
        "/manage-app/apps/categories",
        JSON.stringify({
          restricted_countries: {
            not_contains: session?.account?.account?.country,
          },
        })
      );
      dispatch(setCategoryData(response?.data));
    } catch (err) {
      console.log("Error while fetching categories:", err);
    }
  };

  const handleOpenDetailPage = (data) => {
    setCategoryDetailsInfo({
      id: data?.category_id,
      sub_category: data.sub_category,
      name: data?.category,
      subCategories: categories.filter(
        (category) =>
          category?.category === data?.category && category?.sub_category
      ),
    });
    setIsDetailModalOpen(true);
  };

  const categoryBackgroundImage = (
    <img
      src={bgImage}
      height="79px"
      width="79px"
      className="category-bg-img"
      alt="background ellipse"
    />
  );

  return (
    !!categories.length && (
      <Box className="categories-list">
        {isShowHeading && (
          <MiniAppHeading
            title={browseCategoriesTitle}
            handleAction={() => navigate("search")}
          />
        )}
        <Grid container spacing={2} sx={{ mt: 1, mb: 2 }} padding="0 15px">
          {categories.map((cat, idx) => {
            const colorObj = categoryColors[idx % categoryColors.length];

            return (
              !cat.sub_category && (
                <Grid
                  item
                  xs={6}
                  key={cat.label}
                  onClick={() => handleOpenDetailPage(cat)}
                >
                  <Box
                    className="category-box"
                    sx={{
                      backgroundColor: colorObj.bg,
                      border: `1px solid ${colorObj.border}`,
                    }}
                  >
                    {cat.icon_url && (
                      <Box className="category-img">
                        <img
                          src={cat.icon_url}
                          alt="icon"
                          height="24px"
                          width="24px"
                        />
                      </Box>
                    )}
                    <Text
                      className="default-text"
                      size={16}
                      font="semibold"
                      sx={{ position: "absolute", bottom: "12px" }}
                    >
                      {cat.category}
                    </Text>
                    {categoryBackgroundImage}
                  </Box>
                </Grid>
              )
            );
          })}
        </Grid>
        {isDetailModalOpen && (
          <CategoryDetails
            isOpen={isDetailModalOpen}
            setIsOpen={setIsDetailModalOpen}
            categoryDetail={categoryDetailsInfo}
          />
        )}
      </Box>
    )
  );
}

export default CategoriesList;
